export default __webpack_public_path__ + "static/media/man.356c9546.png";